import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import Table from '~/components2/Table';
import FormSection from '~/pages/admin/civilsearch/common/FormSection';
import store from '../../../store';
import AddLink from './AddLink';
import { columns } from './columns';

export default function AgencyLinks() {
  const { agency } = useSnapshot(store) as typeof store;

  const data = useMemo(() => {
    return Object.values(agency?.links || {});
  }, [agency?.links]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableSorting: true,
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    initialState: {
      sorting: [{ id: 'title', desc: false }],
    },
  });

  return (
    <FormSection title="Agency Links">
      <AddLink />

      <div className="max-h-96 overflow-y-auto">
        <Table id="cs-agency-links-v1" table={table} />
      </div>
    </FormSection>
  );
}
